import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetBatchesByMoId = createModule({
  base: 'GET_BATCHES_BY_MO_ID',
  apiDetails: SERVICE_ENDPOINT.GET_BATCHES_BY_MO_ID,
  errors: { defaultError: false, customError: '' },
});

const GetProductionStageById = createModule({
  base: 'GET_PRODUCTION_STAGE_BY_ID',
  apiDetails: SERVICE_ENDPOINT.GET_PRODUCTION_STAGE_BY_ID({}),
  errors: { defaultError: false, customError: '' },
});
const GetSubJobCardListById = createModule({
  base: 'GET_SUB_JOB_CARD_LIST_BY_ID',
  apiDetails: SERVICE_ENDPOINT.GET_SUB_JOB_CARD_LIST_BY_ID({}),
  errors: { defaultError: false, customError: '' },
});

const CreateSubJobCard = createModule({
  base: 'CREATE_SUB_JOB_CARD',
  apiDetails: SERVICE_ENDPOINT.CREATE_SUB_JOB_CARD,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});
const DeleteSubJobCard = createModule({
  base: 'DELETE_SUB_JOB_CARD',
  apiDetails: SERVICE_ENDPOINT.DELETE_SUB_JOB_CARD,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const UpdateSubJobCardStatus = createModule({
  base: 'UPDATE_SUB_JOB_CARD_STATUS',
  apiDetails: { ...SERVICE_ENDPOINT.UPDATE_SUB_JOB_CARD_STATUS, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetProductionStageEventById = createModule({
  base: 'GET_PRODUCTION_STAGE_EVENT_BY_ID',
  apiDetails: SERVICE_ENDPOINT.GET_PRODUCTION_STAGE_EVENT_BY_ID({}),
  errors: { defaultError: false, customError: '' },
});

const CloseSubJobCard = createModule({
  base: 'CLOSE_SUB_JOB_CARD',
  apiDetails: SERVICE_ENDPOINT.CLOSE_SUB_JOB_CARD({}),
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const IssueProductionQuantities = createModule({
  base: 'ISSUE_PRODUCTION_QUANTITIES',
  apiDetails: SERVICE_ENDPOINT.ISSUE_PRODUCTION_QUANTITIES,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetAvailableBatchesByPsId = createModule({
  base: 'GET_AVAILABLE_BATCHES_BY_PS_ID',
  apiDetails: SERVICE_ENDPOINT.GET_AVAILABLE_BATCHES_BY_PS_ID({}),
  errors: { defaultError: false, customError: '' },
});

export { GetBatchesByMoId, GetProductionStageById, GetSubJobCardListById, CreateSubJobCard, DeleteSubJobCard, UpdateSubJobCardStatus, GetProductionStageEventById, CloseSubJobCard, IssueProductionQuantities, GetAvailableBatchesByPsId };
